<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>الايصالات</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع الايصالات
              <div v-show="$per.value.saveTreasury" class='pull-left' style='padding=0px'>
              </div>
            </div>
            <div class='form-group col-lg-6 col-sm-6' style="padding-top:20px">
              <div class="form-group input-group">
                <span class="input-group-addon">الفرع</span>
                <select @change='FillItineraries()' style="padding: 0px" class="form-control" v-model="branche">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class='form-group col-lg-6 col-sm-6' style="padding-top:20px">
              <div class="form-group input-group">
                <span class="input-group-addon">الخط</span>
                <select style="padding: 0px" class="form-control" v-model="itinerary">
                  <option v-for="item in itineraries" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
                <span class="input-group-btn">
                  <button @click='GetData()' type='button' class='btn btn-default'>
                    عرض
                  </button>
                </span>
              </div>
            </div>
            <!-- <button @click="customerClick()" data-toggle='modal' data-target='#myModal'>افتح المودال</button> -->

            <!-- /.panel-heading -->
            <div class='panel-body'>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th style='text-align: center;'>الرقم</th>
                    <th style='text-align: center;'>الاسم</th>
                    <th style='text-align: center'>النوع</th>
                    <th style='text-align: center'>التاريخ</th>
                    <th style='text-align: center'>الحالة</th>
                    <th style='text-align: center'>المحصل</th>
                    <th style='text-align: center'>مسافة التحصيل</th>
                    <th style='text-align: center'>الموقع</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record, index) in records' :key='record.id'>
                    <td align ='center'>{{record.receipt_id}}</td>
                    <td align ='right'>{{record.name}}</td>
                    <td align ='center'>{{record.type}}</td>
                    <td align ='center'>{{record.exe_date}}</td>
                    <td v-if="record.status === 4" align ='center'>
                      <a href="#" @click="reopen(record.id, index)">{{record.status_str}}</a>
                    </td>
                    <td v-else align ='center'>{{record.status_str}}</td>
                    <td align ='center'>{{record.collector_name}}</td>
                    <td v-if="record.distance !== null" align ='center'>{{record.distance}}م</td>
                    <td v-else align ='center'></td>
                    <td v-if="record.location === null" align ='center'></td>
                    <td v-else align ='center'>
                      <a
                      :href="'https://www.google.com/maps?q=' + record.location"
                      target="_blank"
                      >
                      عرض</a>
                    </td>
                    <td align ='center'>
                      <button v-if="record.status == 3" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#dailyModal'>تسوية</button>                                             </td>
                    </tr>
                  </tbody>
                </table>
                <!-- /.table-responsive -->
              </div>
              <!-- /.panel-body -->
            </div>
            <!-- /.panel -->
          </div>
          <!-- /.col-lg-12 -->
        </div>
      </div>
      <!-- Modal -->
      <div class='modal fade' id='dailyModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
        <div class='modal-dialog  modal-lg'>
          <div class='modal-content'>
            <div class='modal-header'>
              <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
              <h4 class='modal-title' id='myModalLabel'>تسوية ايصالات</h4>
            </div>
            <form role='form'>
              <div class='modal-body'>
                <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                  <ul v-if='validationErrors'>
                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                  </ul>
                </div>
                <div class='alert alert-success alert-dismissable' v-if='successShow'>
                  {{success}}
                </div>
                <fieldset>
                  <table style="border-collapse: collapse;">
                    <tr>
                      <td style="width: 150px; font-size: 14px; border: 1px solid black;padding:5px">ك.الايصال: {{record.receipt_id}}</td>
                      <td style="width: 500px; font-size: 14px; border: 1px solid black;padding:5px">[{{record.cust_id}}] {{record.name}}</td>
                      <td style="width: 100px; font-size: 14px; border: 1px solid black;padding:5px">{{record.exe_date}}</td>
                      <td style="width: 250px; font-size: 14px; border: 1px solid black;padding:5px">المحصل:{{record.collector_name}}</td>
                    </tr>
                  </table>
                  <div class='form-group col-lg-6 col-sm-6'>
                    <label>عقود العروض:</label>
                    <select class="form-control" style="padding: 0px" v-model="offer">
                      <option v-for="item in record.exe_offers" v-bind:key="item.id" v-bind:value="item">
                        {{ item.offer }}
                      </option>
                    </select>
                    <table style="border-collapse: collapse;margin: 10px">
                      <tr>
                        <td style="width: 100px; font-size: 12px; border: 1px solid black;padding:5px">النوع: {{record.receipt_id}}</td>
                        <td style="width: 100px; font-size: 12px; border: 1px solid black;padding:5px">المبلغ: </td>
                        <td style="width: 200px; font-size: 12px; border: 1px solid black;padding:5px">كود العقد: 58965</td>
                        <td style="width: 200px; font-size: 12px; border: 1px solid black;padding:5px">المفوض:{{record.collector_name}}</td>
                      </tr>
                    </table>

                    <table style="border-collapse: collapse;margin: 10px">
                      <tr>
                        <td style="width: 25px; font-size: 14px; border: 1px solid black;padding:2px">م</td>
                        <td style="width: 280px; font-size: 14px; border: 1px solid black;padding:2px">الصنف</td>
                        <td style="width: 40px; font-size: 14px; border: 1px solid black;padding:2px">تسليم</td>
                        <td style="width: 40px; font-size: 14px; border: 1px solid black;padding:2px">تركيب</td>
                      </tr>

                      <tr v-for="(offerItem, recID) in offer.itemsList" v-bind:key="offerItem.id" v-bind:value="offerItem.id">
                        <td style="width: 25px; font-size: 14px; border: 1px solid black;padding:2px">{{recID + 1}}</td>
                        <td style="width: 250px; font-size: 14px; border: 1px solid black;padding:2px">{{offerItem.item}}</td>
                        <td v-if="offerItem.is_delivery == 1" style="width: 40px; font-size: 14px; border: 1px solid black;padding:2px">✔</td>
                        <td v-else style="width: 40px; font-size: 14px; border: 1px solid black;padding:2px">✘</td>
                        <td v-if="offerItem.is_installation == 1" style="width: 40px; font-size: 14px; border: 1px solid black;padding:2px">✔</td>
                        <td v-else style="width: 40px; font-size: 14px; border: 1px solid black;padding:2px">✘</td>
                      </tr>
                    </table>
                  </div>
                  <div class='form-group col-lg-6 col-sm-6'>
                    <label>الصيانة:</label>
                    <input v-model='record.name' class='form-control' name='name' type='text'>
                  </div>
                </fieldset>
              </div>
              <div class='modal-footer'>
                <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                <button  type='button' class='btn btn-primary'>حفظ</button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

      <CustomerDetails  ref="CustomerDetails"> </CustomerDetails>
      <!-- /.container-fluid -->
    </div>

  </template>
<script>
import axios from 'axios'
import CustomerDetails from '@/components/myComponents/CustomerDetails'
export default {
  name: 'Invoices',
  components: {
    CustomerDetails
  },
  data () {
    return {
      branches: [],
      branch: 0,
      validationErrors: '',
      records: {},
      record: {},
      offer: {},
      title: '',
      itineraries: [],
      itinerary: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false
    }
  },
  created () {
    this.branche = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.FillItineraries(this.branche)
  },
  methods: {
    customerClick () {
      this.$refs.CustomerDetails.setCustomerID(5)
    },
    FillItineraries () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branche))
      if (i > -1) {
        this.itineraries = JSON.parse(JSON.stringify(this.branches[i].itineraries))
      }
    },
    // -------------------------------------------------------
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-invoices', {
        token: localStorage.getItem('token'),
        itinerary: this.itinerary
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // -------------------------------------------------------
    reopen (id, index) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'reopen-invoice', {
        token: localStorage.getItem('token'),
        id: id
      })
        .then(({ data }) => {
          this.isLoadingData = false
          this.records[index].status_str = 'جديد'
          this.records[index].status = 0
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // -------------------------------------------------------
    showForm (rec) {
      this.record = rec
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoices/Invoices.vue